export default __webpack_public_path__ + "static/media/839.ccb313e3.gif";